import { useCookieState } from 'ahooks';
import { useABTestIsOn } from '@modules/root/hook/use-growthbook';
import { useEffect, useState } from 'react';

// Client-only variable to prevent flicker during hydration
let hasHydrated = false;

const useFilterDrawerPreference = (): {
    filterDrawerOpen: boolean;
    toggleFilterDrawer: () => void;
} => {
    const isDefaultFilterOpen = useABTestIsOn('default-filter-open');
    const defaultValue = isDefaultFilterOpen.toString();
    const [showFilterCookie, setShowFilterCookie] = useCookieState(
        'showFilter',
        {
            defaultValue,
        }
    );

    // Set a flag after initial hydration
    const [isHydrated, setIsHydrated] = useState(hasHydrated);

    useEffect(() => {
        hasHydrated = true;
        setIsHydrated(true);
    }, []);

    // Use the cookie value for client, and default for server
    // This ensures the same initial value is used on both server and client
    const isDrawerOpen = isHydrated
        ? showFilterCookie === 'true'
        : isDefaultFilterOpen;

    const handleDrawerToggle = () => {
        const currentValue = showFilterCookie === 'true';
        setShowFilterCookie((!currentValue).toString());
    };

    return {
        filterDrawerOpen: isDrawerOpen,
        toggleFilterDrawer: handleDrawerToggle,
    };
};

export { useFilterDrawerPreference };
